import React, { useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import httpInjectorService from 'services/http-injector.service';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Checkbox,
  Input,
  useDisclosure,
  Spinner,
  Box,
  IconButton,
  Select,
} from '@chakra-ui/react';
import { FaTrash, FaSearch } from 'react-icons/fa'; // Import trash icon
import { Card, CardBody } from 'reactstrap';
import { BulletList } from 'react-content-loader';
import TableContainer from 'components/common/TableContainer';
import { HStack } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Empty } from 'antd';
import { demoWorkWeekUsers } from 'components/demodata/Dummydata';

const AssignWork = ({ getworkweeks, activeTab }) => {
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [rules, setRules] = useState([]);
  const [selectedRules, setSelectedRules] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [searchQuery, setSearchQuery] = useState(''); // Search state
  const [isAnyRuleSelected, setIsAnyRuleSelected] = useState(false); // Track if any rule is selected
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page state
  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();
  const {
    isOpen: isDeleteRuleOpen,
    onOpen: onDeleteRuleOpen,
    onClose: onDeleteRuleClose,
  } = useDisclosure();
  const [ruleUserId, setRuleUserId] = useState(null);
  const [ruleWorkId, setRuleWorkId] = useState(null);

  const columns = useMemo(
    () => [
      {
        id: 'select',
        Header: () => (
          <Checkbox
            isChecked={
              selectedUsers.length === filteredUsers.length &&
              filteredUsers.length > 0
            }
            onChange={handleSelectAll}
          />
        ),
        Cell: ({ row }) => {
          const user = row.original;
          return (
            <Checkbox
              isChecked={selectedUsers.includes(user.user_id)}
              onChange={() => handleUserCheckboxChange(user.user_id)}
            />
          );
        },
      },
      {
        Header: 'Username',
        accessor: 'Name',
      },
      {
        Header: 'Employee ID',
        accessor: 'Employee_id',
      },
      {
        Header: 'Designation',
        accessor: 'designations',
      },
      {
        Header: 'Department',
        accessor: 'department_name',
      },
      {
        Header: 'Work Week Rule Name',
        accessor: 'work_week_rule_name',
        Cell: ({ value }) => value || ' ',
      },
      {
        id: 'actions',
        Header: 'Actions',
        Cell: ({ row }) => {
          const user = row.original;

          return (
            <HStack justifyContent="center">
              {user.work_week_rule_name && (
                <IconButton
                  icon={<FaTrash />}
                  colorScheme="red"
                  size="sm"
                  aria-label="Delete Rule"
                  onClick={() =>
                    WorkweekModalOpen(user.user_id, user.work_week_configId)
                  }
                />
              )}
            </HStack>
          );
        },
      },
    ],
    [selectedUsers],
  );

  const getUsers = async () => {
    setIsLoading(true);
    try {
      const isDemoMode = localStorage.getItem('demoMode') === 'true';
                  
      if (isDemoMode) {
        setUsers(demoWorkWeekUsers);
        return;
      }
      const response = await httpInjectorService.getUsersandrules();
      if (response.status === 'success') {
        setUsers(response.data);
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (err) {
      console.log(err, 'assignwork');
    } finally {
      setIsLoading(false);
    }
  };

  const getorgworkrule = async () => {
    setIsLoading(true);
    try {
      const response = await httpInjectorService.getorgworkrule();
      if (response.status === 'success') {
        setRules(response.data);
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleUserCheckboxChange = (userId) => {
    setSelectedUsers((prevSelected) => {
      if (prevSelected.includes(userId)) {
        return prevSelected.filter((id) => id !== userId);
      } else {
        return [...prevSelected, userId];
      }
    });
  };

  const handleRuleCheckboxChange = (ruleId) => {
    setSelectedRules((prevSelected) => {
      let updatedSelectedRules;
      if (prevSelected.includes(ruleId)) {
        updatedSelectedRules = prevSelected.filter((id) => id !== ruleId);
      } else {
        updatedSelectedRules = [...prevSelected, ruleId];
      }

      if (updatedSelectedRules.length === 0) {
        setIsAnyRuleSelected(false);
      } else {
        setIsAnyRuleSelected(true);
      }

      return updatedSelectedRules;
    });
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(e.target.value);
  };

  const deleteRuleForUser = async () => {
    try {
      const payload = {
        userId: ruleUserId,
        work_week_rule_id: ruleWorkId,
      };
      const response = await httpInjectorService.deleteUserRule(payload);
      if (response.status === 'success') {
        toast.success('Rule deleted successfully!', {
          position: 'top-right',
          autoClose: 3000,
        });
        setUsers((prevUsers) =>
          prevUsers.map((user) =>
            user.user_id === ruleUserId
              ? { ...user, work_week_rule_name: ' ' }
              : user,
          ),
        );
        getUsers();
        setRuleUserId(null);
        setRuleWorkId(null);
        onDeleteClose();
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        setRuleUserId(null);
        setRuleWorkId(null);
        onDeleteClose();
      }
    } catch (err) {
      toast.error('Error deleting rule.', {
        position: 'top-right',
        autoClose: 3000,
      });
      setRuleUserId(null);
      setRuleWorkId(null);
      onDeleteClose();
    } finally {
      getworkweeks();
    }
  };

  useEffect(() => {
    if (activeTab === '2') getUsers();
  }, [activeTab]);

  const openModal = () => {
    if (selectedUsers.length === 0) {
      toast.error('Please select at least one user to assign work.', {
        position: 'top-right',
        autoClose: 3000,
      });
    } else {
      getorgworkrule();
      onOpen();
    }
  };

  const handleAssignWork = async () => {
    if (selectedUsers.length === 0) {
      toast.error('Please select at least one user to assign work.', {
        position: 'top-right',
        autoClose: 3000,
      });
      return;
    }

    if (selectedRules.length === 0) {
      toast.error('Please select at least one rule to assign work.', {
        position: 'top-right',
        autoClose: 3000,
      });
      return;
    }

    if (!selectedDate) {
      toast.error('Please select a date to assign work.', {
        position: 'top-right',
        autoClose: 3000,
      });
      return;
    }

    try {
      const usersObj = selectedUsers.reduce((obj, userId) => {
        obj[userId] = true;
        return obj;
      }, {});

      const payload = {
        usersID: usersObj,
        ruleID: selectedRules,
        date: selectedDate,
      };

      const response = await httpInjectorService.Assignwork(payload);
      if (response.status === 'success') {
        toast.success('Workweek assigned successfully!', {
          position: 'top-right',
          autoClose: 3000,
        });
        onClose();
        setSelectedUsers([]);
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (err) {
      toast.error('Error while assigning work.', {
        position: 'top-right',
        autoClose: 3000,
      });
    } finally {
      getUsers();
      getworkweeks();
    }
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allUserIds = filteredUsers.map((user) => user.user_id);
      setSelectedUsers(allUserIds);
    } else {
      setSelectedUsers([]);
    }
  };

  const filteredUsers = users.filter((user) => {
    const username = user.Name ? user.Name.toLowerCase() : '';
    const employeeId = user.Employee_id ? user.Employee_id.toString() : '';
    const department = user.department_name
      ? user.department_name.toLowerCase()
      : '';
    const designation = user.designations
      ? user.designations.toLowerCase()
      : '';

    return (
      username.includes(searchQuery.toLowerCase()) ||
      employeeId.includes(searchQuery.toLowerCase()) ||
      department.includes(searchQuery.toLowerCase()) ||
      designation.includes(searchQuery.toLowerCase())
    );
  });

  const WorkweekModalOpen = (user_id, work_id) => {
    setRuleUserId(user_id);
    setRuleWorkId(work_id);
    onDeleteOpen();
  };

  return (
    <React.Fragment>
      <div>
        {filteredUsers.length === 0 && !isLoading ? (
          <Box textAlign="center" mt={6}>
            <Empty />
          </Box>
        ) : (
          <Button
            onClick={openModal}
            colorScheme="purple"
            rounded={2}
            float="right"
            size="sm"
          >
            <FontAwesomeIcon icon={faPlus} />
            &nbsp; Assign Work week
          </Button>
        )}
      </div>

      {isLoading ? (
        <Box>
          <BulletList />
        </Box>
      ) : filteredUsers.length === 0 ? (
        <div></div>
      ) : (
        <TableContainer
          columns={columns}
          isGlobalFilter={true}
          data={filteredUsers}
          customPageSize={rowsPerPage}
          className="custom-header-css"
        />
      )}

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Assign Work</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div>
              <h4>Select Work Rules</h4>
              {isLoading ? (
                <Box display="flex" justifyContent="center">
                  <Spinner size="lg" />
                </Box>
              ) : rules?.length > 0 ? (
                rules.map((rule) => (
                  <div key={rule.id}>
                    <Checkbox
                      isChecked={selectedRules.includes(rule.id)}
                      onChange={() => handleRuleCheckboxChange(rule.id)}
                      isDisabled={
                        isAnyRuleSelected && !selectedRules.includes(rule.id)
                      } // Disable if any rule is selected
                    >
                      {rule.work_week_rule_name}
                    </Checkbox>
                  </div>
                ))
              ) : (
                <p>No rules available</p>
              )}
            </div>

            <div style={{ marginTop: '10px' }}>
              <Input
                type="date"
                value={selectedDate}
                onChange={handleDateChange}
                placeholder="Select a date"
              />
            </div>
          </ModalBody>

          <ModalFooter>
            <Button size="sm" rounded={2} colorScheme="red" onClick={onClose}>
              Cancel
            </Button>
            &nbsp;
            <Button
              size="sm"
              rounded={2}
              colorScheme="purple"
              onClick={handleAssignWork}
            >
              Assign Work Week
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isDeleteOpen} onClose={onDeleteClose} size="md">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirm Deletion</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Are you sure you want to delete this assign workweek?
          </ModalBody>
          <ModalFooter>
            <Button
              size="sm"
              rounded={2}
              onClick={onDeleteClose}
              colorScheme="purple"
              mr={3}
            >
              No
            </Button>
            <Button
              size="sm"
              rounded={2}
              colorScheme="red"
              onClick={deleteRuleForUser}
            >
              Yes
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </React.Fragment>
  );
};

export default AssignWork;
